import {Label} from '@primer/react'

import labelStyles from '../EntryStatusLabel.module.css'
import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function MergingStatusLabel({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Merging) return null

  return (
    <Label variant="done" className={labelStyles.solid}>
      Merging
    </Label>
  )
}
